import { render, staticRenderFns } from "./MenuDownloadSample.vue?vue&type=template&id=4a29f731&"
import script from "./MenuDownloadSample.vue?vue&type=script&lang=js&"
export * from "./MenuDownloadSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports